import { render, staticRenderFns } from "./ReceptionsPage.vue?vue&type=template&id=ee2cfd0c&scoped=true"
import script from "./ReceptionsPage.vue?vue&type=script&lang=js"
export * from "./ReceptionsPage.vue?vue&type=script&lang=js"
import style0 from "./ReceptionsPage.vue?vue&type=style&index=0&id=ee2cfd0c&prod&lang=scss&scoped=true"
import style1 from "./ReceptionsPage.vue?vue&type=style&index=1&id=ee2cfd0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2cfd0c",
  null
  
)

export default component.exports